import { useSSRQuery } from '../graphql';
import FETCH_STADIUM_CONFIG from '../pageComponents/stadiumPage/fetchStadiumConfig.query.graphql.js';

const useStadiumConfig = () => {
  const { data: stadiumConfig, loading: isLoading } = useSSRQuery(
    FETCH_STADIUM_CONFIG
  );

  let stadiumProductIds;
  let stadiumBookingCacheCounter;
  stadiumProductIds =
    stadiumConfig?.application?.configurations?.allegiantStadiumProductIds;
  stadiumBookingCacheCounter =
    stadiumConfig?.application?.configurations
      ?.allegiantStadiumBookingCacheCounter;

  if (stadiumProductIds && stadiumProductIds.length) {
    stadiumProductIds = stadiumProductIds.split(',').map(Number);
  }

  return {
    isLoading,
    stadiumProductIds,
    stadiumBookingCacheCounter,
  };
};
export default useStadiumConfig;
